<small class="debug">{{me}}</small>
<div class="location_properties">
  @if (dynamicsInitialized) {
    <div>
      <dynamic-form
        [fields]="uiConfigInit"
        [ignoreValidation]="true"
        (submit)="submit($event)">
      </dynamic-form>
      <br/>
    </div>
  }
</div>
<mat-tab-group (selectedIndexChange)="tabChange($event)" [@.disabled]="true" tabGroupDrag mat-stretch-tabs="false" mat-align-tabs="start">
  <mat-tab label="{{'general.defaultPlaylist' | transloco}}">
    <div #tab1>
    </div>
  </mat-tab>
  <mat-tab label="{{'general.gpsLocation' | transloco}}">
    <div #tab2>
    </div>
  </mat-tab>
</mat-tab-group>
<ng-template let-modal #locationPageModal>
  <div mat-dialog-content style="overflow: hidden; height: 500px">
    <!--        <h1 class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>-->
    <!--            <mat-icon class="pull-right">drag_indicator</mat-icon>-->
  <!--        </h1>-->
  <div mat-dialog-content>
    <div class="row">
      <button mat-button class="pull-right" (click)="openAssociateDialog(false, 'pageGps')">
        <mat-icon>attach_file</mat-icon>
      </button>
      <form [formGroup]="formSettings" (ngSubmit)="submit($event)" novalidate>
        <input inputrestriction="basic1"  type="hidden" formControlName="sourceId">
        <input inputrestriction="basic1"  type="hidden" formControlName="sourceType">
        <div fxLayout="column">
          <mat-form-field fxFlex>
            <mat-label>connect to</mat-label>
            <input inputrestriction="basic1"  matInput type="text" autocomplete="off" placeholder="" formControlName="sourceName">
            @if ((this.formSettings.controls.sourceName.dirty || this.formSettings.controls.sourceName.touched) && this.formSettings.controls.sourceName.invalid) {
              <div class="relative">
                <mat-error>{{'general.valueIsInvalid' | transloco}}</mat-error>
              </div>
            }
          </mat-form-field>
          <mat-form-field fxFlex>
            <mat-label>{{'placeholder.page' | transloco}}</mat-label>
            <input inputrestriction="basic1"  matInput type="text" autocomplete="off" placeholder="" formControlName="page">
            @if ((this.formSettings.controls.page.dirty || this.formSettings.controls.page.touched) && this.formSettings.controls.page.invalid) {
              <div class="relative">
                <mat-error>{{'general.valueIsInvalid' | transloco}}</mat-error>
              </div>
            }
          </mat-form-field>
          <mat-form-field fxFlex>
            <mat-label>{{'placeholder.type' | transloco}}</mat-label>
            <input inputrestriction="basic1"  matInput type="text" autocomplete="off" placeholder="" formControlName="type">
            @if ((this.formSettings.controls.type.dirty || this.formSettings.controls.type.touched) && this.formSettings.controls.type.invalid) {
              <div class="relative">
                <mat-error>{{'general.valueIsInvalid' | transloco}}</mat-error>
              </div>
            }
          </mat-form-field>
          <mat-form-field fxFlex>
            <mat-label>{{'placeholder.lat' | transloco}}</mat-label>
            <input inputrestriction="basic1"  matInput type="number" autocomplete="off" placeholder="" formControlName="lat">
            @if ((this.formSettings.controls.lat.dirty || this.formSettings.controls.lat.touched) && this.formSettings.controls.lat.invalid) {
              <div class="relative">
                <mat-error>{{'general.valueIsInvalid' | transloco}}</mat-error>
              </div>
            }
          </mat-form-field>
          <mat-form-field fxFlex>
            <mat-label>{{'placeholder.lng' | transloco}}</mat-label>
            <input inputrestriction="basic1"  matInput type="number" autocomplete="off" placeholder="" formControlName="lng">
            @if ((this.formSettings.controls.lng.dirty || this.formSettings.controls.lng.touched) && this.formSettings.controls.lng.invalid) {
              <div class="relative">
                <mat-error>{{'general.valueIsInvalid' | transloco}}</mat-error>
              </div>
            }
          </mat-form-field>
          <mat-form-field fxFlex>
            <mat-label>{{'placeholder.duration' | transloco}}</mat-label>
            <input inputrestriction="basic1"  matInput type="number" autocomplete="off" placeholder="" formControlName="duration">
            @if ((this.formSettings.controls.duration.dirty || this.formSettings.controls.duration.touched) && this.formSettings.controls.duration.invalid) {
              <div class="relative">
                <mat-error>{{'general.valueIsInvalid' | transloco}}</mat-error>
              </div>
            }
          </mat-form-field>
          <br/>
          <div fxFlex>
            <mat-label>{{'placeholder.radius' | transloco}} (km)</mat-label>
            <br/>
            <mat-slider discrete disableRipple color="accent" min="0" max="100" step="0.1">
              <input matSliderThumb formControlName="radios"/>
            </mat-slider>
            @if ((this.formSettings.controls.radios.dirty || this.formSettings.controls.radios.touched) && this.formSettings.controls.radios.invalid) {
              <div class="relative">
                <mat-error>{{'general.valueIsInvalid' | transloco}}</mat-error>
              </div>
            }
          </div>
          <br/>
          <div fxFlex>
            <mat-label>{{'placeholder.priority' | transloco}}</mat-label>
            <br/>
            <!--                            <input inputrestriction="basic1"  type="range" min="0" max="100" autocomplete="off" placeholder="{{'placeholder.priority' | transloco}}" formControlName="priority">-->
            <mat-slider discrete disableRipple color="accent" min="0" max="100" step="1">
              <input matSliderThumb formControlName="priority"/>
            </mat-slider>
            @if ((this.formSettings.controls.priority.dirty || this.formSettings.controls.priority.touched) && this.formSettings.controls.priority.invalid) {
              <div class="relative">
                <mat-error>{{'general.valueIsInvalid' | transloco}}</mat-error>
              </div>
            }
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
</ng-template>


